export const DEFAULT_SCROLL_TOP = 400;

export enum visibleSlidesQnt {
    MAX = 4,
    MID = 3,
    MIN = 2
}